import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import React, { useState, useEffect } from "react";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Helmet } from "react-helmet";
import DuesShow from "./FeeDuesShow";
import FeesCards from "./FeesCards";
import DemandReports from "../Reports/DemandReports";
import ShowEvent from "./ShowEvent";
import FeesChart from "../chart/feeschart";
import schoolApi from "../../api/schoolApi";
import { usePermissions } from "../contexts/PermissionContext";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const Home = (props) => {
  const { rolePermissions, userInfo } = usePermissions();
  const [leads, setLeads] = useState([]);
  const [registered, setRegistered] = useState(0);
  const [notRegistered, setNotRegistered] = useState(0);
  const [allAnouncement, setAllAnouncement] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await schoolApi.fetchlead();

        if (result && result.success) {
          const registered = result.leads.filter(
            (item) => item.status === "Registered"
          ).length;
          const notRegistered = result.leads.filter(
            (item) => item.status === "Not Registered"
          ).length;
          setRegistered(registered);
          setNotRegistered(notRegistered);
          setLeads(result.data);
        } else {
          setLeads([]);
        }
      } catch (error) {
        setLeads([]); // Reset leads on error
      }

      try {
        const anouncementData = await schoolApi.getAllAnouncement();
        setAllAnouncement(anouncementData.result.slice(0, 2));
      } catch (error) {
        console.error("Error fetching announcements:");
      }
    }
    fetchData();
  }, []);
  const studentGenderData = {
    labels: ["Registered", "Enquiry"],
    datasets: [
      {
        data: [registered, notRegistered],
        backgroundColor: ["#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#36A2EB", "#FF6384"],
      },
    ],
  };

  return (
    <>
      <Container fluid className="">
        <Helmet>
          <title>{props?.tabName}</title>
        </Helmet>
        {(userInfo?.userrole === "SYS_ADMIN" ||
          userInfo?.userrole === "ADMIN") && (
          <Row className="">
            <FeesCards />
          </Row>
        )}

        <Row>
          <Col lg={5}>
            {(userInfo?.userrole === "SYS_ADMIN" ||
              userInfo?.userrole === "ADMIN") && (
              <Row className="ms-1">
                <Card className="p-3 shadow-sm d-flex justify-content-between align-items-center">
                  <Card.Title className="text-center">
                    Student Admission Chart
                  </Card.Title>
                  <div style={{ height: "300px" }}>
                    <Doughnut data={studentGenderData} />
                  </div>
                </Card>
              </Row>
            )}
            <Row className="ms-1">
              <Card className="shadow-sm mt-3 notice-board">
                <Card.Header className="text-center fw-bold bg-light">
                  Notice Board
                </Card.Header>
                <ListGroup variant="flush">
                  {allAnouncement.map((ac, index) => (
                    <ListGroup.Item key={index} className="p-3 notice-item">
                      <h6 className="fw-bold mb-1">{ac.title}</h6>
                      <p
                        className="homeAnouncement"
                        dangerouslySetInnerHTML={{ __html: ac.description }}
                      ></p>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card>
              {}
              <Card className="shadow-sm p-0 mt-3">
                <Card.Header className="text-center">
                  Event Calendar
                </Card.Header>
                <ShowEvent />
              </Card>
            </Row>
          </Col>
          {(userInfo?.userrole === "SYS_ADMIN" ||
            userInfo?.userrole === "ADMIN") && (
            <Col lg={7}>
              <Row className="mx-1">
                <Card className="p-3 shadow-sm">
                  <Card.Header className="text-center">
                    Demand Report
                  </Card.Header>
                  <DemandReports />
                </Card>
              </Row>
              <Row className="mx-1 mt-3">
                <Card className="p-3 shadow-sm">
                  <Card.Header className="text-center">
                    Fee Pending Report
                  </Card.Header>
                  <DuesShow />
                </Card>
              </Row>
              <Row className="mx-1 mb-3 mt-3">
                <Card className="p-3 shadow-sm">
                  <Card.Title className="text-center">
                    Class Fees Summary
                  </Card.Title>
                  <FeesChart />
                </Card>
              </Row>
            </Col>
          )}
        </Row>
        {}
      </Container>
    </>
  );
};
export default Home;